/* Flèches mobiles pour les sections "swipe on mobile" */
if (!customElements.get('swipe-arrows')) {
  class SwipeArrows extends HTMLElement {
    connectedCallback() {
      this.scroller = this.querySelector(this.dataset.target);
      this.prev = this.querySelector('[data-swipe-prev]');
      this.next = this.querySelector('[data-swipe-next]');
      if (!this.scroller || !this.prev || !this.next) return;

      this.update = this.update.bind(this);
      this.onScroll = () => {
        cancelAnimationFrame(this.raf);
        this.raf = requestAnimationFrame(this.update);
      };
      this.onPrev = () => this.go(-1);
      this.onNext = () => this.go(1);

      this.prev.addEventListener('click', this.onPrev);
      this.next.addEventListener('click', this.onNext);
      this.scroller.addEventListener('scroll', this.onScroll, { passive: true });
      this.addEventListener('load', this.onScroll, true); // images lazy-loadées
      window.addEventListener('resize', this.onScroll);
      if ('ResizeObserver' in window) {
        this.ro = new ResizeObserver(this.onScroll);
        this.ro.observe(this.scroller);
      }
      this.update();
    }

    disconnectedCallback() {
      if (!this.scroller) return;
      this.prev.removeEventListener('click', this.onPrev);
      this.next.removeEventListener('click', this.onNext);
      this.scroller.removeEventListener('scroll', this.onScroll);
      this.removeEventListener('load', this.onScroll, true);
      window.removeEventListener('resize', this.onScroll);
      if (this.ro) this.ro.disconnect();
    }

    items() {
      return Array.from(this.scroller.children).filter((el) => el.offsetWidth > 0);
    }

    step() {
      const items = this.items();
      if (items.length > 1) {
        const d = Math.abs(items[1].offsetLeft - items[0].offsetLeft);
        if (d > 0) return d;
      }
      return this.scroller.clientWidth;
    }

    go(dir) {
      this.scroller.scrollBy({ left: dir * this.step(), behavior: 'smooth' });
    }

    update() {
      const s = this.scroller;
      const max = s.scrollWidth - s.clientWidth;
      this.classList.toggle('swipe-arrows--active', max > 2);
      this.prev.disabled = s.scrollLeft <= 2;
      this.next.disabled = s.scrollLeft >= max - 2;

      // Centre les flèches verticalement sur l'image (et non sur tout le bloc texte compris)
      const first = this.items()[0];
      const media = first && first.querySelector('.aspect-ratio, .collection-card__image, figure, img');
      if (media && media.offsetHeight > 0) {
        const top = media.getBoundingClientRect().top - this.getBoundingClientRect().top + media.offsetHeight / 2;
        this.style.setProperty('--swipe-arrows-top', top + 'px');
      } else {
        this.style.removeProperty('--swipe-arrows-top');
      }
    }
  }
  customElements.define('swipe-arrows', SwipeArrows);
}

/* Mode carrousel (Flickity) : masque la flèche inutile en début / fin de carrousel */
(function () {
  function initCarouselArrows() {
    if (typeof Flickity === 'undefined') return;
    document.querySelectorAll('.mobile-arrows.flickity-enabled:not([data-mobile-arrows])').forEach(function (el) {
      var flkty = Flickity.data(el);
      if (!flkty) return;
      el.dataset.mobileArrows = 'true';
      var prev = el.querySelector('.flickity-prev'), next = el.querySelector('.flickity-next');
      if (!prev || !next) return;
      var update = function () {
        if (flkty.options.wrapAround) return;
        prev.classList.toggle('is-disabled', flkty.selectedIndex <= 0);
        next.classList.toggle('is-disabled', flkty.selectedIndex >= flkty.slides.length - 1);
      };
      flkty.on('select', update);
      flkty.on('settle', update);
      update();
    });
  }
  document.addEventListener('DOMContentLoaded', function () { setTimeout(initCarouselArrows, 0); });
  window.addEventListener('load', initCarouselArrows);
  document.addEventListener('shopify:section:load', function () { setTimeout(initCarouselArrows, 100); });
})();